
export const eventEmitter = {
    events: {},

    subscribe(event: string, subscriberUid: string, callback: (data: any) => void) {
        if (!this.events[event]) this.events[event] = [];
        this.events[event].push({ uid: subscriberUid, callback });
    },

    unsubscribe(event: string, subscriberUid: string) {
        if (!this.events[event]) return;

        for (let i = 0; i < this.events[event].length; i++) {
            if (this.events[event][i].uid === subscriberUid) {
                this.events[event].splice(i, 1);
                break;
            }
        }
    },

    publish(event: string, data: any) {
        if (!this.events[event]) return;
        this.events[event].forEach(subscriber => subscriber.callback(data));
    },

    publishByUid(event: string, subscriberUid: string, data: any) {
        if (!this.events[event]) return;
        this.events[event].forEach(subscriber => { if (subscriber.uid === subscriberUid) { subscriber.callback(data); } });
    }
}